import type { StoreActionApi } from 'react-sweet-state';

import { colors } from '../constants';
import { type ColorStore } from '../state/types';

const getColor =
	(id: string) =>
	({ getState, setState }: StoreActionApi<ColorStore>) => {
		const { colorMap } = getState();
		if (colorMap[id]) {
			return colorMap[id];
		}
		const index = Object.keys(colorMap).length % colors.length;
		const color = colors[index];
		setState({ colorMap: { ...colorMap, [id]: color } });
		return color;
	};

export const actions = {
	getColor,
};
